import React, {useState, useEffect} from 'react'


function Bar(props) {
    const { color, votes, ...other } = props;
    return <div className={votes ? `bar max-h-6 border box-border border-white flex-1 min-h-1` : `bar border max-h-6 border-white flex-1 hidden min-h-1`} style={{width: votes, backgroundColor: color}} {...other} />;
}

const MajorityMeter = ({data, longText, seatTotal, majority, limit}) => {
    
    const [maxSeats, setMaxSeats] = useState(25)
    const [majorityPosition, setMajorityPosition] = useState(50);
    
    useEffect(()=> {
        if (data) {
            let leadingParty = data.partyResults[0];
            if (leadingParty.seats >= majority) {
                setMaxSeats(leadingParty.seats);
                setMajorityPosition(majority/leadingParty.seats*100)
            } else {
                setMaxSeats(majority)
                setMajorityPosition(majority/majority*100)
            }
        }
    }, [data, seatTotal, majority])

    return (
        <div className={'classes.meter h-full flex flex-col relative py-2 w-11/12 min-h-[50px]'}>
            {data && data.partyResults.sort((a,b)=>{
								if (a.seats > b.seats) {
									return -1
								} else if (a.seats < b.seats) {
									return 1
								} else return 0
							}).map((party, i)=>{
                if (i < 4) {
                    return <Bar key={i} color={party.color} votes={party.seats > 0 ? `${(party.seats/maxSeats)*100}%` : '0.5%'} />
                } 
                if (!limit) {
                    return <Bar key={i} color={party.color} votes={party.seats > 0 ? `${(party.seats/maxSeats)*100}%` : '0.5%'} />
                }
            })    
            }
            {longText && <div aria-hidden="true" className={'hidden xs:block absolute -top-6 font-bold'} style={{right: `${100-majorityPosition}%`}}>{majority} seats needed for majority</div>}
            {<div aria-hidden="true"  className={longText ? 'block xs:hidden absolute -top-5 font-bold' : 'text-xs absolute -top-5 font-bold font-light'} style={{left: `${majorityPosition}%`}}>{majority}</div>}
            <div className={'classes.majorityLine absolute h-full border-l-black border-l-2 pr-1 bottom-1'} style={{left: `${majorityPosition}%`}}/>
        </div>
    );
}
export default MajorityMeter;